import { constants } from '../utils'
import base from './base'

const { headers, url, request } = base

const getAllStates = async () =>
  request(url(constants.api.address.states), {
    method: 'GET',
    headers: headers(),
  })

const getCitiesByState = async stateId =>
  request(url(constants.api.address.cities(stateId)), {
    method: 'GET',
    headers: headers(),
  })

const searchByCity = async (id, term) =>
  request(url(constants.api.address.searchByCityAndTerm(id, term)), {
    method: 'GET',
    headers: headers(),
  })

const searchByZipcode = async zipcode =>
  request(url(constants.api.address.searchByZipcode(zipcode)), {
    method: 'GET',
    headers: headers(),
  })

const addressApi = {
  getAllStates,
  getCitiesByState,
  searchByCity,
  searchByZipcode,
}

export default addressApi
